import { spawnTrackingEventListners } from 'components/tracking-ga-events'
import { handleHasAccountInputs } from 'landings/__assets__/scripts/component/account-inputs'
import { handleCompetitionForm } from 'landings/__assets__/scripts/component/competition-form'

function init(): void {
  // set GA/GTM events tracking
  spawnTrackingEventListners()

  // handle hero form state
  handleHasAccountInputs()

  // Competition Form
  //set true if registered mail is required
  //set true if answer is optional
  handleCompetitionForm(true, false)
}

init()
